import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import ReferralLinkMixin from '@/helpers/vue_mixins/v2/ReferralLinkMixin';
import { required } from 'vuelidate/lib/validators';
import CreateReferralLink from '@/plugins/graphql/mutations/v2/referral-link-create.gql';
import UpdateReferralLink from '@/plugins/graphql/mutations/v2/referral-link-update.gql';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ReferralLinks from '@/plugins/graphql/queries/v2/referral/referral-links-by-app.gql';
import ReferralLinkFragment from '@/plugins/graphql/fragments/v2/referral-link.gql';
import { requiredProperty } from '@/helpers/mixins/LocalizationHelper';
import { SalesChannel } from '@/helpers/entities/enums/v2/SalesChannel';
import BaseText from '@/components/BaseText.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { selectOptionBuilder } from '@/helpers/select_option_builder';
import ReferralLinksCount from '@/plugins/graphql/queries/v2/referral/referral-links-count.gql';
import SmartRetailLinksCount from '@/plugins/graphql/queries/v2/referral/smart-retail-links-count.gql';
import SmartRetailLinks from '@/plugins/graphql/queries/v2/referral/smart-retail-links-by-app.gql';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let ReferralLinkForm = class ReferralLinkForm extends Mixins(Mixins(FormValidationsMixin, FormMixin, RouterParamsAppMixin, ViewportSizeMixin, ReferralLinkMixin), CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.mutationRequestOnFlight = false;
        this.toggle = false;
        this.selectedReferralLink = null;
        this.form = {
            name: '',
            code: '',
            salesChannel: '',
        };
    }
    spaceDetected(text) {
        return /\s/.test(text);
    }
    get refLinkName() {
        if (this.form.salesChannel === 'glife') {
            return 'Smart Retail Link Name';
        }
        return 'Referral Link Name';
    }
    get refLinkCode() {
        if (this.form.salesChannel === 'glife') {
            return 'Custom URL';
        }
        return 'Customized Link';
    }
    toggleForm(obj) {
        if (obj) {
            this.selectedReferralLink = obj;
            if (obj.uuid) {
                this.form = {
                    referralLinkUuid: obj.uuid,
                    name: obj.name,
                    code: obj.code,
                    salesChannel: obj.salesChannel,
                };
            }
        }
        this.toggle = !this.toggle;
    }
    onCancel() {
        this.resetForm();
        this.toggle = !this.toggle;
    }
    async create() {
        const appUuid = this.appUUID;
        const { name, code, salesChannel } = this.form;
        return this.$apollo.mutate({
            mutation: CreateReferralLink,
            variables: {
                input: {
                    appUuid,
                    name,
                    code,
                    salesChannel,
                },
            },
            // update(cache: any, { data }: any) {
            //   const queryOptions = {
            //     query: ReferralLinks,
            //     variables: {
            //       appUuid,
            //       first: 10,
            //       after: null,
            //       keyword: null,
            //     },
            //   };
            //   const { referralLinksByApp } = cache.readQuery({ ...queryOptions });
            //   const cachedReferralLinks = {
            //     ...referralLinksByApp,
            //   };
            //   cachedReferralLinks.edges.unshift({
            //     node: data.createReferralLink.referralLink,
            //   });
            //   cache.writeQuery({
            //     ...queryOptions,
            //     data: {
            //       referralLinksByApp: cachedReferralLinks,
            //     },
            //   });
            // },
            refetchQueries: [
                {
                    query: ReferralLinksCount,
                    variables: {
                        appUuid,
                    },
                },
                {
                    query: ReferralLinks,
                    variables: {
                        appUuid,
                        first: 10,
                        after: null,
                        keyword: null,
                    },
                },
                {
                    query: SmartRetailLinksCount,
                    variables: {
                        appUuid,
                    },
                },
                {
                    query: SmartRetailLinks,
                    variables: {
                        appUuid,
                        keyword: null,
                    },
                },
            ],
        });
    }
    async update() {
        const { name, code, referralLinkUuid, salesChannel } = this.form;
        return this.$apollo.mutate({
            mutation: UpdateReferralLink,
            variables: {
                input: {
                    referralLinkUuid,
                    name,
                    code,
                    salesChannel,
                },
            },
            update(cache, { data }) {
                const { referralLink } = data.updateReferralLink;
                referralLink.uuid = referralLinkUuid;
                cache.writeFragment({
                    id: referralLinkUuid,
                    fragment: ReferralLinkFragment,
                    data: referralLink,
                    fragmentName: 'ReferralLink',
                });
            },
        });
    }
    async onSubmit() {
        this.$v.$touch();
        const mutation = () => {
            if (this.form.referralLinkUuid) {
                this.referralAction('SUBMIT EDIT');
                return this.update();
            }
            this.referralAction('SUBMIT CREATE');
            return this.create();
        };
        if (!this.$v.$invalid) {
            this.mutationRequestOnFlight = !this.mutationRequestOnFlight;
            await mutation()
                .then(() => {
                const action = this.form.referralLinkUuid ? 'Updated' : 'Created';
                this.successNotification(`Referral Link Successfully ${action}`);
            })
                .catch((e) => {
                this.errorNotification(e.message);
            })
                .finally(() => {
                this.onCancel();
                this.mutationRequestOnFlight = !this.mutationRequestOnFlight;
            });
        }
    }
    get codeFieldErrors() {
        const errors = [];
        if (!this.$v.form.code.$dirty) {
            return errors;
        }
        if (!this.$v.form.code.required) {
            const msg = requiredProperty('Code');
            errors.push(msg);
        }
        if (!this.$v.form.code.shouldNotAllowSpace) {
            const msg = 'Space is not allowed';
            errors.push(msg);
        }
        return errors;
    }
    get buildSubmitButton() {
        if (this.form.referralLinkUuid) {
            return 'Save';
        }
        return 'Add';
    }
    get selectOptions() {
        const options = [selectOptionBuilder(SalesChannel.messenger)];
        if (this.app.subscribedToInstagramBot) {
            options.push(selectOptionBuilder(SalesChannel.instagram));
        }
        if (this.app?.gcashAppId) {
            options.push({ value: SalesChannel.glife, text: `GLife` });
        }
        return options;
    }
};
__decorate([
    Prop({ type: String, required: true })
], ReferralLinkForm.prototype, "header", void 0);
__decorate([
    Prop({ type: Object, required: true })
], ReferralLinkForm.prototype, "app", void 0);
ReferralLinkForm = __decorate([
    Component({
        components: {
            ActionButton,
            BaseTextField,
            FormHeader,
            BaseText,
        },
        validations() {
            const vm = this;
            return {
                form: {
                    name: {
                        required,
                    },
                    code: {
                        required,
                        shouldNotAllowSpace: () => {
                            if (!vm.spaceDetected(vm.form.code)) {
                                return true;
                            }
                            return false;
                        },
                    },
                    salesChannel: {
                        required,
                    },
                },
            };
        },
    })
], ReferralLinkForm);
export default ReferralLinkForm;
